import numeral from 'numeral';

export const formatPrice = (
  price,
  withCurrency = false,
  withDecimal = false
) => {
  let priceFormatter = '0,0';

  if (withDecimal) {
    priceFormatter += '.00';
  }

  if (withCurrency) {
    priceFormatter += '$';
  }

  return numeral(price).format(priceFormatter);
};
